import React, { useEffect, useState } from 'react'
import { ProjectService } from '../../services/ProjectService';
import { usePagination } from '../../hooks/usePagination';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSearch } from '../../context/SearchContext';
import TableComponent from '../../Components/Comman/TableComponent';
import Pagination from '../../Components/Comman/Pagination';
import { CheckCircle, Circle, CircleX, Eye, FileText, SquareCheckBig, SquarePlus } from 'lucide-react';
import ArticleDetailsModal from '../../Modal/Admin/ArticleDetailsModal';
import MobClientArticles from '../../Components/Feature/clients/MobClientArticles';


export default function ArticlesClient() {
  const {debounceSearchTerm}=useSearch();
  const [refresh, setRefresh] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const {currentPage,totalPages,goToPage,setTotalPages}=usePagination();
  const navigate = useNavigate();
  const [showArticleModal, setShowArticleModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState({
    title: "",
    abstract: "",
  });
  const [sortOrder, setSortOrder] = useState("DESC");

  const fetchDocuments = async () => {
        setLoading(true);
        try {
          const response=await ProjectService.getProjectDocumentsArticles(currentPage,10,debounceSearchTerm,sortOrder);
          if(response){
            setDocuments(response?.data);
            setTotalPages(response?.pagination?.totalPages)
          }
        } catch (error) {
          toast.error(error?.message)
        } finally {
          setLoading(false); 
        }
  }

  useEffect(()=>{
    fetchDocuments();
  },[debounceSearchTerm,currentPage,refresh,sortOrder,setTotalPages]);
  
  useEffect(() => {
      if (currentPage !== 1) {
        goToPage(1);
      }
  }, [debounceSearchTerm ,sortOrder]);

  const handleViewDocument = async (doc) => {
    let objectUrl;
  
    try {
      const response = await ProjectService.viewDocumentById(doc.id);
  
      if (!response?.data || !response?.type) {
        toast.error("Document data not found.");
        return;
      }
  
      const mimeType = response.type;
      const base64Data = response.data.includes(",")
        ? response.data.split(",")[1]
        : response.data;
  
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const blob = new Blob([byteNumbers], { type: mimeType });
      objectUrl = URL.createObjectURL(blob);
  
      const newTab = window.open(objectUrl, "_blank");
  
      if (!newTab) {
        // Popup was blocked; provide an alternative link.
        const link = document.createElement("a");
        link.href = objectUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.textContent = "Open document";
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
  
      // Keep the Blob URL alive while the new tab loads.
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
    } catch (error) {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      toast.error(error?.message || "Failed to view document");
    }
  };

  const handleViewArticleDetails = (doc, field) => {
    setSelectedArticle({
      title: doc.title ?? "",
      abstract: doc.abstract ?? "",
    });

    setShowArticleModal(true);
  };

  const columns = [
        {
          label: "Project ID",
          field: "projectId",
          width: "10%",
          headerClassName: "text-left pl-2 border-l border-t border-b border-[#d3cccc]",
          className: "text-[14px] text-left pl-2 border-l border-[#d3cccc] whitespace-normal break-words",
        },
       
       
        {
                label: "Title",
                field: "title",
                headerClassName:
                  "text-left pl-2 border-t border-b border-[#d3cccc]",
                className:
                "text-[14px] text-left pl-2 whitespace-normal break-words",
                render: (doc) => (
                <p
                  className="line-clamp-2 max-w-[400px]"
                  title="Click to view full title and abstract"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewArticleDetails(doc, "title");
                  }}
                >
                {doc.title ?? "-"}
               </p>
                ),
        },
        {
                label: "Abstract",
                field: "abstract",
                headerClassName:
                  "text-left pl-2 border-t border-b border-[#d3cccc]",
                className:
                "text-[14px] text-left pl-2 whitespace-normal break-words",
                render: (doc) => (
                <p
                  className="line-clamp-2 max-w-[400px]"
                  title="Click to view full title and abstract"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewArticleDetails(doc, "abstract");
                  }}
                >
                {doc.abstract ?? "-"}
               </p>
                ),
        },
        { 
          label: "Date",
          field: "uploadBy",
          width: "15%",
          headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
          className: "text-[14px] text-left pl-2 border-[#d3cccc] whitespace-normal break-words",
          render: (doc) => (
            <div className='flex flex-col'>
                <p className="">
                  {doc.uploadDate ?? "-"}
                </p>
            </div>
          ),
        },
      
        {
          label: 'Action',
          width: "10%",
          headerClassName: '  border-r border-t border-b border-[#d3cccc]',
          className: 'text-[14px] border-r border-[#d3cccc] w-[10%]',
          render: (item) => (
            <div className="flex flex-row items-center gap-2 justify-center">
                    <FileText
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewDocument(item);
                      }}
                      className="!text-blue-600 text-xl cursor-pointer"
                    />

                    <Eye
                      className="!text-green-600 text-xl cursor-pointer" 
                      onClick={() =>
                        navigate("/client/articles-journals", {
                          state: {
                            projectId: item.projectId,
                            documentId: item.id,
                          },
                        })
                      }
                    />
                    
            
            </div>
          )
        }
      
  ]
  return (
    <section className="p-3">

      <div className="flex flex-wrap items-center justify-end gap-3 pb-2">
        <div className="flex items-center gap-2">
          
          <select
            id="articleSortOrder"
            value={sortOrder}
            onChange={(e) => {
              setSortOrder(e.target.value);
              goToPage(1);
            }}
            className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#521785] focus:ring-1 focus:ring-[#521785]"
          >
            <option value="DESC">Newest First</option>
            <option value="ASC">Oldest First</option>
          </select>
        </div>
      </div>

      <div className="px-1 py-2 w-full space-y-4 flex flex-col">
        {!loading && (
          <>
            <div className="hidden lg:block w-full overflow-x-auto">
              <TableComponent columns={columns} data={documents} headerBg="bg-[#f6f6f6]" />
            </div>

            <div className="block lg:hidden">
              <MobClientArticles
                documents={documents}
                onViewDocument={handleViewDocument}
                onViewDetails={handleViewArticleDetails}
                onViewJournals={(item) =>
                  navigate("/client/articles-journals", {
                    state: { projectId: item.projectId, documentId: item.id },
                  })
                }
              />
            </div>
          </>
        )}

        {!loading && documents.length > 0 && (
          <div>
            <Pagination currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} />
          </div>
        )}
      </div>

      <ArticleDetailsModal
        isOpen={showArticleModal}
        onClose={() => setShowArticleModal(false)}
        title={selectedArticle.title}
        abstract={selectedArticle.abstract}
      />
    </section>
  )
}
